/**
 * @internal
 */
export const TemplateConstants = {
    NameDefault: 'default',
    NameEmpty: 'empty',
    GroupDefault: 'default',
    GroupList: 'list',
    GroupEditAdvanced: 'edit-advanced',
    GroupView: 'view',
    GroupApp: 'app',
    GroupUnknown: 'unknown',
    ButtonSeparator: ',',
};
